<template>
  <div>
    <!-- Suggested replies and actions in chip list -->
    <div class="quick-reply-button-container"  :class="{  'flexCenter' :suggestionChips.length == 0, 'centerLayout' : selectedLayout == 'vertical' && carousel_type !== 'carousel'}">
      <div class="flex-between gap10P">
        <div v-if="suggestionChips && suggestionChips.length" class="quick-reply-buttons-wrapper">
          <div class="text-button-wrapper" v-for="(thisSuggestionChip, bIndex) in suggestionChips" :key="'element button' + bIndex">
            <button class="btn-template-dynamic-action" @click="parseButtonInfo(thisSuggestionChip, bIndex, 'suggestions')" :class="{ 'activeReplyButton': bIndex === activeButtonIndex }" :disabled="isViewOnlyMode">
              <template v-if="thisSuggestionChip.type !== undefined">
                <img v-if="getIconForButton(thisSuggestionChip).includes('/')" :src="getIconForButton(thisSuggestionChip)" class="btn-icon-img" :class="{ 'active_icon': bIndex == activeButtonIndex }" alt="" />
                <VIcon v-else :name="getIconForButton(thisSuggestionChip)" size="default" class="txt_clr_primary paddingRight10P" :class="{ 'active_icon': bIndex == activeButtonIndex }"></VIcon>
              </template>
              <span class="replyBttnTitle">{{ thisSuggestionChip.text || thisSuggestionChip.title }}</span>
            </button>
          </div>
        </div>
        <div class="text-button-wrapper" v-if="suggestionChips && suggestionChips.length < 11">
          <button class="btn-template-dynamic-action" @click="addNewSuggestionChip()" :disabled="isViewOnlyMode">
            + Add New
          </button>
        </div>
      </div>
    </div>
    <div v-if="shouldShowPopper" class="popperContainer">
      <popper :type="openPopper" :showDynamicURL="false" channel="googlercs" :is_agent_or_group_req="true" :showSuggestionReplies="showSuggestionReplies" :deleteButton="true" :config="popperConfig" @closePopper="closePopper"  @submit="popperSubmit" @deleteBttn="removeButton"/>
    </div>
  </div>  
</template>

<script>

import popper from '/src/components/popper';
import { getIcon } from '@/helpers/icon.helper';
import { useUIStore } from '@/stores/ui';

export default {
  emits: ["finalChipsData"],
  components: {
    popper,
  },
  props: {
    selectedLayout: {
      type: String,
      default: ''
    },
    carousel_type: {
      type: String,
      default: ''
    },
    carousel_messages: {
      type: Object,
      default: function () {
        return {
          buttons: [],
        };
      },
    },
    isViewOnlyMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      openPopper: undefined,
			popperIndex: -1,
      popperConfig: {
				text: undefined,
				action: undefined,
				payload: undefined,
        type: undefined,
        extrainfo: undefined
			},
      suggestionChips: [
      ],
      showSuggestionReplies: false,
      activeButtonIndex: null,
    };
  },
  mounted() {
    this.initializeSuggestionChips();
  },
  computed: {
		shouldShowPopper(){
			return this.openPopper === 'detailed'
		}
	},
  methods: {
    initializeSuggestionChips() {
      const carouselButtons = this.carousel_messages?.buttons || [];
      // Add `text` field from `title` for each button
      const transformedButtons = carouselButtons.map(button => {
        return {
          ...button,
          text: button.text || button.title || ''
        };
      });

      this.suggestionChips = [...this.suggestionChips, ...transformedButtons];
    },
    popperSubmit(result) {
      const data = result.new;
      const chip = this.suggestionChips[this.popperIndex];
      
			if (this.popperIndex > -1 && chip) {
        // Set common properties for all chip types
        Object.assign(chip, {
          text: data.text,
          payload: data.payload,
          postback_action_type: data.postback_action_type,
          postback_action: data.postback_action
        });

        // Handle action-specific properties
        switch (data.action) {
					case 'location':
            chip.type = 'location';
            chip.extrainfo = data.extrainfo;
						break;
          case 'share':
            chip.type = 'share';
						break;
          case 'calendar':
            chip.type = 'calendar';
            chip.extrainfo = data.extrainfo;
						break;
          case 'phone_number':
            chip.type = 'phone_number';
						break;
          case 'website':
            chip.type = 'webview';
            chip.url = data.payload;
            chip.url_type = data.url_type;
						break;
          case 'app_webview':
            chip.type = 'app_webview';
            chip.url = data.payload;
            chip.url_type = data.url_type;
            chip.extrainfo = data.extrainfo;
						break;
          case 'custom':
            chip.type = 'postback';
            break;
          case 'agent_or_group':
            chip.type = 'postback';
            chip.payload = '7@1k704um@9 ___' + data.payload;
            chip.payload = data.payload;
            break;
          default:
            chip.type = 'QUICK_REPLY';
						break;
				}
			}
      
			this.openPopper = undefined;
			this.popperIndex = -1;
      this.activeButtonIndex = null;
      this.$emit('finalChipsData', this.suggestionChips); 
		},
    parseButtonInfo(buttonInfo, bttnIndex){
      if(this.shouldShowPopper){
				return useUIStore().updateToast({ open: true, message: "Please save your changes to the current button before editing a new one.", type: "warning" })
			}	
			this.openPopper = 'detailed'; // QuickReply buttons Popper
			this.popperIndex =  bttnIndex;
      if (buttonInfo.type === 'webview' && buttonInfo.url) {
        buttonInfo.payload = buttonInfo.url;
        buttonInfo.url_type = buttonInfo.url_type;
      }
			this.popperConfig = buttonInfo;
      //this.showSuggestionReplies = true;
      this.activeButtonIndex = bttnIndex; // tracking individual Buttons
		},
    removeButton() {
			try {
				if(this.popperIndex > -1) {
          this.suggestionChips.splice(this.popperIndex, 1);
          this.$emit('finalChipsData', this.suggestionChips); 
				}
			} catch (error) {
				console.error("Exception", error);
			} finally {
				this.openPopper = undefined;
				this.popperIndex = -1;
        this.activeButtonIndex = -1;
			}
		},
    closePopper() {
      this.openPopper = undefined;
      this.buttonIndex = -1;
      this.activeButtonIndex = undefined
    },
    addNewSuggestionChip() {
      this.suggestionChips.push({ text: 'Suggestion', type: undefined, payload: undefined }); 
    },
    getIconForButton(button) {
      return getIcon(button);
    }
  }
}
</script>

<style scoped>
.quick-reply-button-container {
  max-width: 500px;
  overflow-x: scroll;
  margin: 0px 24%;
  padding: 10px 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  flex-direction: row;
}
.quick-reply-buttons-wrapper {
  display: flex;
  column-gap: 10px;
}

.text-button-wrapper {
  display: flex;
  width: 100%;
  position: relative;
}
.btn-template-dynamic-action {
  cursor: pointer;
  min-width: 120px;
  width: 220px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 16px;
  border: 1px solid var(--purple);
  border-radius: 20px;
  background: transparent;
  color: var(--purple);
  font-size: 14px;
  margin: 0;
  transition: background-color 0.2s;
}
.btn-template-dynamic-action:hover {
  background: var(--purple-opac);
}
.btn-template-dynamic-action:disabled {
  opacity: 0.5;
  pointer-events: none;
}
.btn-icon-img {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.activeReplyButton {
  background: var(--purple) !important;
  color: var(--white) !important;
}
.activeReplyButton .replyBttnTitle, .active_icon{
  color: var(--white) !important;
}
.popperContainer{
  border: 1px solid var(--background-primary);
  border-radius: 5px;
  padding: 10px 20px;
  margin: 20px 0px 20px 0px;
}
.flexCenter{
  justify-content: center;
  padding-right: 40px;
}
.centerLayout{
  margin: 0px 15%;
}
</style>